import ApiPro6pp from '@adivare/api-pro6pp';

const pro6pp = new ApiPro6pp();

export default pro6pp;
